import { Component, Input, ViewEncapsulation, OnInit } from '@angular/core';
import { ContentsCatalogPageContent } from '@vestiaire/api-sdk-angular/model/contentsCatalogPageContent';
import { ISearchState } from '@app/shared/model/interfaces/store/search-state';

@Component({
  selector: 'vc-catalog-seo-content',
  templateUrl: './catalog-seo-content.component.html',
  styleUrls: ['./catalog-seo-content.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class CatalogSeoContentComponent implements OnInit {
  @Input()
  content: ContentsCatalogPageContent;
  @Input()
  searchStore: ISearchState | null;
  seoContentsTitle: string;

  constructor() {}

  ngOnInit() {
    if (this.searchStore && this.searchStore.searchValue) {
      this.seoContentsTitle =
        this.searchStore.searchValue.charAt(0).toUpperCase() + this.searchStore.searchValue.substr(1);
    } else if (this.content && this.content.headline) {
      this.seoContentsTitle = this.content.headline;
    }
  }
}
